import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { navigationActions } from '../../_actions/navigation.actions';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, Card, CircularProgress, Grid, Hidden, IconButton, Menu, MenuItem, Modal, Snackbar, Typography } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { isNull } from 'lodash';
import { getSelectedArea } from '../../_reducers/theme.reducer';
import { PLATFORMS } from '../../_helpers/constants';
import _ from 'lodash';
import EditIcon from '@material-ui/icons/Edit';
import MissingFeaturesModal from '../MissingFeaturesModal';
import { getActiveMissingFeatures } from '../../_helpers/missingFeatures';
import { mobilizeiStoresService } from '../../_services/mobilizei/stores.service';

const useStyles = makeStyles(() => ({
    appBar: {
        backgroundColor: '#fff',
        height: 56
    },
    toolbar: {
        height: 56,
        minHeight: 56,
        justifyContent: 'space-between',
    },
    progress: {
        margin: '0 20px'
    },
    icon: {
        marginLeft: 10
    },
    hideMenuItem: {
        display: 'none'
    },
    button: {
        backgroundColor: '#3cd568',
        color: '#fff',
        textTransform: 'lowercase',
        "&:hover": {
            backgroundColor: '#2a9548',
        }
    },
    modal: {
        position: 'absolute',
        width: '30%',
        padding: 0,
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        padding: 15
    },

}));

function Header(props) {
    const classes = useStyles(props);
    const dispatch = useDispatch();
    const platformId = useSelector(state => state.StoreReducer.platform);
    const categoryOrder = useSelector(state => state.StoreReducer.categoryOrder);
    const theme = useSelector(state => state.ThemeReducer);

    const selectedArea = useSelector(state => getSelectedArea(state));

    const storeData = useSelector(state => state.UserReducer.user.store);
    const isWebviewTheme = theme.key == 'webview';

    const [anchorEl, setAnchorEl] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [showChangeThemeButton, setShowChangeThemeButton] = useState(theme.key !== storeData.activeTheme);
    const [showModal, setShowModal] = useState(false);

    const missingFeatures = _.get(storeData, 'missingFeatures', [])
    const [activeMissingFeatures, setActiveMissingFeatures] = useState({});
    const [showMissingFeaturesModal, setShowMissingFeaturesModal] = useState(false);

    const [alert, setAlert] = useState({
        message: '',
        open: false,
        severity: 'success'
    });

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleAreaSelect = (index) => {
        if (!isNull(index)) {
            dispatch(navigationActions.selectArea(index));
        }
        setAnchorEl(null);
    };

    const handleSave = () => {
        // Check if there is any missing feature that is activated
        const amf = getActiveMissingFeatures(missingFeatures, theme);
        if(!_.isEmpty(amf)) {
            setActiveMissingFeatures(amf);
            setShowMissingFeaturesModal(true);
            return;
        }

        setIsSaving(true);

        const generalSetting = {
            generalSettings: {
                ...storeData.generalSettings,
                categoryOrder: categoryOrder
            }
        }
        
        try {
            mobilizeiStoresService.updateStoreById(storeData?.platformId, storeData?.id, generalSetting)
            mobilizeiStoresService.setTheme(storeData?.platformId, storeData?.id, theme.key, theme)
            setAlert({
                open: true,
                message: 'Configurações salvas com sucesso!',
                severity: 'success'
            });
        } catch (error) {
            setAlert({
                open: true,
                message: 'Não foi possível salvar as suas configurações. Por favor, tente novamente.',
                severity: 'error'
            });
        } finally {
            setIsSaving(false);

        }
    }

    const handleSelectTheme = () => {
        setShowModal(false)
        setIsLoading(true);

        const data = { activeTheme: theme.key }

        mobilizeiStoresService.updateStoreById(storeData.platformId, storeData.id, data)
            .then(() => {
                setAlert({
                    open: true,
                    message: 'Tema selecionado com sucesso!',
                    severity: 'success'
                });
                setShowChangeThemeButton(false)
                window.top.postMessage({type: 'theme', themeKey: theme.key}, '*');
            })
            .catch(() => {
                setAlert({
                    open: true,
                    message: 'Não foi possível selecionar o tema. Por favor, tente novamente.',
                    severity: 'error'
                });
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    return (
        <AppBar position="absolute" className={classes.appBar}>
            <Toolbar className={classes.toolbar}>

                <MissingFeaturesModal
                    activeMissingFeatures={activeMissingFeatures}
                    setAlert={setAlert}
                    setShowModal={setShowMissingFeaturesModal}
                    showModal={showMissingFeaturesModal}
                />

                <Snackbar
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    autoHideDuration={6000}
                    onClose={() => setAlert({ ...alert, open: false })}
                    open={alert.open}
                    style={{ position: 'absolute' }}
                >
                    <Alert elevation={6} variant="filled" severity={alert.severity}>
                        {alert.message}
                    </Alert>
                </Snackbar>

                <Box display="flex">
                    <Hidden smUp implementation="css" display="inline">
                        <IconButton aria-label="edit" onClick={props.handleSideMenuToggle}>
                            <EditIcon />
                        </IconButton>
                    </Hidden>

                    {!isWebviewTheme && (
                        <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick} className='screen-selector'>
                            <Hidden smUp implementation="css" display="inline">
                                <span style={{ textTransform: 'none' }}>Tela:&nbsp;</span>
                            </Hidden>
                            <Hidden xsDown implementation="css" display="inline">
                                <span style={{ textTransform: 'none' }}>Tela selecionada:&nbsp;</span>
                            </Hidden>

                            {selectedArea.title}
                            <FontAwesomeIcon icon={['fas', 'chevron-down']} className={classes.icon} />
                        </Button>
                    )}
                    
                    <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={() => handleAreaSelect(null)}
                    >
                        {theme.areas.map((area, index) => {

                            switch(platformId){
                                case PLATFORMS.NUVEMSHOP:
                                    if(area.key != 'cartScreen'){
                                        return (
                                            <MenuItem
                                                key={`area-selector-${index}`}
                                                onClick={() => handleAreaSelect(index)}
                                                className={platformId === PLATFORMS.NUVEMSHOP && area.key === 'loginScreen' ? classes.hideMenuItem : ''}
                                            >
                                                {area.title}
                                            </MenuItem>
                                        )
                                    }
                                    break;
                                case PLATFORMS.IRROBA:
                                    if(area.key != 'productDetailsScreen' && area.key != 'cartScreen'){
                                        return (
                                            <MenuItem
                                                key={`area-selector-${index}`}
                                                onClick={() => handleAreaSelect(index)}
                                                className={platformId === PLATFORMS.NUVEMSHOP && area.key === 'loginScreen' ? classes.hideMenuItem : ''}
                                            >
                                                {area.title}
                                            </MenuItem>
                                        )
                                    }
                                    break;
                                default:
                                    return (
                                        <MenuItem
                                            key={`area-selector-${index}`}
                                            onClick={() => handleAreaSelect(index)}
                                            className={platformId === PLATFORMS.NUVEMSHOP && area.key === 'loginScreen' ? classes.hideMenuItem : ''}
                                        >
                                            {area.title}
                                        </MenuItem>
                                    );
                            }
                        })}
                    </Menu>
                </Box>

                <Box display="flex" style={{ gap: 10 }}>
                    {showChangeThemeButton && (
                        isLoading ? (
                            <CircularProgress className={classes.progress} />
                        ) : (
                            < Button className={classes.button} variant="contained" onClick={() => setShowModal(true)}>
                                Usar tema
                            </Button>
                        )
                    )}

                    {isSaving ? (
                        <CircularProgress className={classes.progress} />
                    ) : (
                        <Button className={classes.button} variant="contained" onClick={() => handleSave()}>
                            Salvar
                        </Button>
                    )}
                </Box>
            </Toolbar>

            <Modal
                disableAutoFocus
                disableEnforceFocus
                onClose={() => setShowModal(false)}
                open={showModal}
            >
                <Card className={classes.modal}>
                    <Typography gutterBottom variant="h6" align="left">
                        Tem certeza que deseja usar este tema?
                    </Typography>

                    <Typography gutterBottom>Ao clicar em salvar, este tema passará a ser o tema ativo do seu aplicativo e ficará disponível imediatamente.</Typography>

                    <Grid container justifyContent='space-between'>
                        <Button color="secondary" size="small" onClick={() => setShowModal(false)}>
                            Cancelar
                        </Button>
                        <Button color="secondary" size="small" className={classes.button} onClick={() => handleSelectTheme()}>
                            Salvar
                        </Button>
                    </Grid>
                </Card>
            </Modal>
        </AppBar >
    );
}

export default Header;